module.exports = __webpack_public_path__ + "img/课程介绍_06.861af1e7.jpg";